// src/pages/AdminPanel.jsx
import React, { useState } from 'react';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import AdminWorkflows  from './admin/AdminWorkflows';
import AdminNodes      from './admin/AdminNodes';
import AdminCloud      from './admin/AdminCloud';
import AdminParameters from './admin/AdminParameters';

const SECTIONS = [
  { id: 'workflows',  label: 'Workflows',  icon: '⬡' },
  { id: 'nodes',      label: 'Nodes',      icon: '◈' },
  { id: 'cloud',      label: 'Cloud',      icon: '☁' },
  { id: 'parameters', label: 'Parameters', icon: '◉' },
];

export default function AdminPanel({ user }) {
  const [section, setSection] = useState('workflows');

  async function handleSignOut() {
    await signOut(auth);
  }

  const contentMap = {
    workflows:  <AdminWorkflows />,
    nodes:      <AdminNodes />,
    cloud:      <AdminCloud />,
    parameters: <AdminParameters />,
  };

  return (
    <div style={{ minHeight: '100vh', fontFamily: "'Source Serif 4', serif", background: '#0a1220' }}>

      {/* ── Sticky top bar ── */}
      <header style={{ background: '#071020', position: 'sticky', top: 0, zIndex: 100 }}>
        {/* Logo + sign out row */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '12px clamp(12px, 4vw, 28px)',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
        }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
            <span style={{ fontFamily: "'Playfair Display', serif", fontSize: 18, fontWeight: 700, color: '#fff' }}>
              Comfy<span style={{ color: '#38bdf8' }}>Stack</span>
            </span>
            <span style={{
              fontFamily: "'JetBrains Mono', monospace", fontSize: 9,
              color: 'rgba(255,255,255,0.4)', letterSpacing: 2,
              border: '1px solid rgba(255,255,255,0.15)',
              padding: '1px 6px', borderRadius: 10,
            }}>ADMIN</span>
          </div>
          <button
            onClick={handleSignOut}
            style={{
              padding: '5px 14px',
              background: 'rgba(255,255,255,0.08)',
              border: '1px solid rgba(255,255,255,0.2)',
              borderRadius: 6, fontSize: 12,
              color: '#fff', cursor: 'pointer',
              fontFamily: "'Source Serif 4', serif",
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.18)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}
          >Sign out</button>
        </div>

        {/* Horizontal section tabs */}
        <nav style={{ display: 'flex', padding: '0 clamp(12px, 4vw, 28px)', overflowX: 'auto' }}>
          {SECTIONS.map(s => {
            const active = section === s.id;
            return (
              <button
                key={s.id}
                onClick={() => setSection(s.id)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 6,
                  padding: '10px 18px',
                  background: 'none', border: 'none',
                  borderBottom: active ? '2.5px solid #38bdf8' : '2.5px solid transparent',
                  color: active ? '#38bdf8' : 'rgba(255,255,255,0.5)',
                  fontSize: 14, cursor: 'pointer',
                  fontFamily: "'Source Serif 4', serif",
                  fontWeight: active ? 500 : 400,
                  transition: 'color 0.15s, border-color 0.15s',
                  marginBottom: '-1px', whiteSpace: 'nowrap',
                }}
                onMouseEnter={e => { if (!active) e.currentTarget.style.color = '#fff'; }}
                onMouseLeave={e => { if (!active) e.currentTarget.style.color = 'rgba(255,255,255,0.5)'; }}
              >
                <span>{s.icon}</span>
                {s.label}
              </button>
            );
          })}
        </nav>
      </header>

      {/* ── Main content ── */}
      <main style={{ padding: 'clamp(16px, 3vw, 32px) clamp(12px, 4vw, 40px) 60px', maxWidth: 900, margin: '0 auto' }}>
        {/* Breadcrumb */}
        <div style={{
          fontFamily: "'JetBrains Mono', monospace", fontSize: 10,
          color: '#38bdf8', letterSpacing: 1,
          textTransform: 'uppercase', marginBottom: 24,
          display: 'flex', alignItems: 'center', gap: 6,
        }}>
          <span style={{ opacity: 0.5 }}>Admin</span>
          <span style={{ opacity: 0.3 }}>/</span>
          <span>{SECTIONS.find(s => s.id === section)?.label}</span>
        </div>

        {contentMap[section]}
      </main>
    </div>
  );
}
